import React, { Component, createRef } from "react";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import SwalServices from "../../services/swalServices/SwalServices.js";
import { CommonValidationMessages } from "../../utils/Messages.js";
import { isValidForm } from "../../utils/validation/CommonValidator.js";
import ValidationText from "../../utils/validation/ValidationText.js";
import moment from "moment";
import DespatchServices from "../../services/axioServices/apiServices/DespatchServices.js";
import { getAuthProps } from "../../utils/AuthenticationLibrary.js";
import { printFunction } from "../../components/print/printTemplate.js";

class NearExpiryStockReport extends Component {
    constructor(props) {
        super(props);
        this.printRef = createRef();
        this.despatchServices = new DespatchServices();
        this.commonServices = new CommonServices();
        this.SwalServices = new SwalServices();
        this.state = {
            companyName: '',
            totalCount: 0,
            tableStatus: "",
            filterDetails: {
                days: ''
            },
            nearExpiryStockRecordsList: [],
            validationRules: {
                days: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "days"
                        ),
                    },
                ],
            },
            validState: {
                isValid: true,
                error: {},
            },
        }
    }

    componentDidMount() {
        const company = getAuthProps()
        this.setState({ companyName: company?.companyName })
    }

    handleChange = (event, name) => {
        let value = event.target.value;
        let details = this.state.filterDetails
        details[name] = value;
        this.setState({ filterDetails: details })
    };

    getAllNearExpiryStockReport = () => {
        let isAllFieldsValidate = this.isAllFieldsValidate()
        if (isAllFieldsValidate) {
            this.setState({ tableStatus: "Loading..." })
            let request = this.state.filterDetails
            request.days = Number(request.days)
            this.despatchServices.getAllNearExpiryStockReport(request).then((response) => {
                if (response.statusCode === 200 && response.responseData != null) {
                    let totalCount = response.responseData.length
                    if (response.responseData.length === 0) {
                        this.setState({ tableStatus: "No Record Found" })
                    } else {
                        this.setState({ tableStatus: "" })
                    }
                    this.setState({ nearExpiryStockRecordsList: response.responseData, totalCount: totalCount })
                } else {
                    this.setState({ tableStatus: "" })
                    this.SwalServices.Error(response.Message);
                }
            })
        }
    }

    isAllFieldsValidate = () => {
        const newValidState = isValidForm(
            this.state.filterDetails,
            this.state.validationRules,
            this.state.validState
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid
    }

    render() {
        return (
            <div className="nearExpiryReport-page reports-page">
                <div className="item-grp flex gap-2.5 w-[30%] !mb-2.5">
                    <div className="input-grp w-full">
                        <label>Days</label>
                        <input
                            className={`inputFocus ${this.state.validState?.error?.days ? "errorInput" : ""}`}
                            type="number"
                            id="days"
                            name="days"
                            value={this.state.filterDetails.days}
                            onChange={(event) => this.handleChange(event, "days")}
                            style={{ width: "100%" }}
                        />
                        {/* <ValidationText
                            error={this.state.validState.error.days}
                        /> */}
                    </div>
                    <div className="btn-grp mt-auto">
                        <button className={`add-btn  mt-auto}`} onClick={() => this.getAllNearExpiryStockReport()}>Search</button>
                        {this.state.totalCount > 0 ?
                            <button className={`print-btn ${(this.state.validState.isValid === false) ? 'mb-[12px]' : 'mb-0'}`} onClick={() => printFunction()}>Print</button>
                            : null}
                    </div>


                </div>

                <div>
                    <p className="mb-[3px] text-[15px] font-medium text-[#474747]">Total Count :- {this.state.totalCount ? this.state.totalCount : 0}</p>
                </div>

                <div class="item-listing">
                    <div className="hidden print-title">
                        <h4 className="text-black font-semibold text-[18px]">Near Expiry Stock Report</h4>
                        <p className="text-black">Days:- {this.state.filterDetails.days}</p>
                    </div>
                    <div class="itemList-table">
                        <div class="table-container" style={{ height: "calc(100vh - 145px)" }}>
                            <table class="itemList">
                                <thead>
                                    <tr>
                                        <td style={{ width: "5%" }} className="w-[15%] no-print">Sr.</td>
                                        <td style={{ width: "20%" }} className="w-[20%]">Item Name</td>
                                        <td style={{ width: "15%" }} className="w-[15%]">Mfg. Date</td>
                                        <td style={{ width: "15%" }} className="w-[15%]">Exp. Date</td>
                                        <td style={{ width: "15%" }} className="w-[15%]">Batch No.</td>
                                        <td style={{ width: "15%" }} className="w-[15%]">Quantity</td>
                                        <td style={{ width: "15%" }} className="w-[15%]">Days Remain</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.nearExpiryStockRecordsList && this.state.nearExpiryStockRecordsList.length > 0 ?
                                        this.state.nearExpiryStockRecordsList.map((details, key) => (

                                            <tr key={key}>
                                                <td className="no-print">{key + 1}</td>
                                                <td>{details.productId?.ItemName}</td>
                                                <td>{moment(details.mfgDate).format('DD MMM YYYY')}</td>
                                                <td>{moment(details.expDate).format('DD MMM YYYY')}</td>
                                                <td>{details.batchNo}</td>
                                                <td>{details.quantity}</td>
                                                <td>{details.dayDifference}</td>
                                            </tr>

                                        )) : this.state.nearExpiryStockRecordsList && this.state.nearExpiryStockRecordsList.length === 0 && this.state.tableStatus !== "" ? (
                                            <tr>
                                                <td colSpan={7} style={{ textAlign: "center", fontSize: "16px" }}>
                                                    {this.state.tableStatus}
                                                </td>
                                            </tr>
                                        ) : this.state.nearExpiryStockRecordsList && this.state.nearExpiryStockRecordsList.length === 0 && this.state.tableStatus === "" ? null : ""}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                {/*----- Print layout -----*/}
                <div className='table-print mt-5 hidden' id="printableArea">
                    {/* Header */}
                    <div className="print-header">
                        <table className="hdr-table">
                            <tbody>
                                <tr>
                                    <td>
                                        <div className="co-name">{this.state.companyName}</div>
                                        <div className="rpt-sub">Near Expiry Stock Report</div>
                                    </td>
                                    <td>
                                        <div className="hdr-meta">
                                            Months Remain: <strong>{this.state.filterDetails.days}</strong>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div className="rule-thick" />
                        <div className="rule-thin" />
                    </div>


                    <div className="print-content">

                        {/* <div className="info-row">
                                                      <div>
                                                        <span className="info-label">Item Name:</span>
                                                        <p className="info-value">Paracetamol</p>
                                                      </div>
                                                    </div> */}

                        {/* Table */}
                        <table className="data-tbl">
                            <colgroup>
                                <col style={{ width: "10%" }} />
                                <col style={{ width: "30%" }} />
                                <col style={{ width: "12%" }} />
                                <col style={{ width: "13%" }} />
                                <col style={{ width: "10%" }} />
                                <col style={{ width: "10%" }} />
                                <col style={{ width: "15%" }} />
                            </colgroup>

                            <thead>
                                <tr>
                                    <th style={{ textAlign: 'left' }}>
                                        Sr No
                                    </th>
                                    <th style={{ textAlign: 'left' }}>
                                        Item Name
                                    </th>
                                    <th style={{ textAlign: 'left' }}>
                                        Mfg Date
                                    </th>
                                    <th style={{ textAlign: 'left' }}>
                                        Exp Date
                                    </th>
                                    <th style={{ textAlign: 'left' }}>
                                        Batch No
                                    </th>
                                    <th style={{ textAlign: 'center' }}>
                                        Quantity
                                    </th>
                                    <th style={{ textAlign: 'center' }}>
                                        Days Remaining
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                {this.state.nearExpiryStockRecordsList && this.state.nearExpiryStockRecordsList.length > 0 ?
                                    this.state.nearExpiryStockRecordsList.map((details, key) => (
                                        <tr key={key}>
                                            <td style={{ textAlign: 'left' }}>
                                                {key + 1}
                                            </td>
                                            <td style={{ textAlign: 'left' }}>
                                                {details.productId?.ItemName}
                                            </td>
                                            <td style={{ textAlign: 'left' }}>
                                                {moment(details.mfgDate).format('DD MMM YYYY')}
                                            </td>
                                            <td style={{ textAlign: 'center' }}>
                                                {moment(details.expDate).format('DD MMM YYYY')}
                                            </td>
                                            <td style={{ textAlign: 'center' }}>
                                                {details.batchNo}
                                            </td>
                                            <td style={{ textAlign: 'center' }}>
                                                {details.quantity}
                                            </td>
                                            <td style={{ textAlign: 'center' }}>
                                                {details.dayDifference}
                                            </td>
                                        </tr>
                                    )) : (
                                        <tr>
                                            <td colSpan="7" style={{ textAlign: 'center' }}>
                                                No Data Found
                                            </td>
                                        </tr>
                                    )}
                            </tbody>
                        </table>
                    </div>

                    {/* Footer */}
                    <div className="print-footer">
                        <div className="rule-foot">
                            <table className="foot-tbl">
                                <tbody>
                                    <tr>
                                        <td>* System generated report. No signature required.</td>
                                        <td style={{ textAlign: "right" }}>
                                            Printed: {new Date().toLocaleDateString("en-GB")} {new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}
export default NearExpiryStockReport;
